<template>
  <div>
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
 
 
 
          
          
<!-- start officers -->



<div style="margin-top:100px"><h4>Share Certificate Details</h4></div>

  
<card class="form-horizontal">
	
	 <h5>Certificate No: {{share_cert.cert_number}}</h5>		
	      
<div>
	<span v-if="share_cert.shareholder.person">
		{{share_cert.shareholder.person.first_name}}  {{share_cert.shareholder.person.last_name}} ( {{share_cert.shareholder.person.gov_id}}) 
	</span>

	<span v-if="share_cert.shareholder.shareholder_company">
		{{share_cert.shareholder.shareholder_company.company_name}} ( {{share_cert.shareholder.shareholder_company.company_reg_num}}) 
	</span>


	::  {{share_cert.num_shares}} {{share_cert.share_type_str}}  Shares 
	
	 (Issued {{share_cert.effective_date_str}}) 
	 
	 <div style="font-weight:bold;margin:20px 0px;color:red;">
		 <span v-if="share_cert.cancelled_date">
			Cancelled: {{share_cert.cancelled_date_str}}
		 </span>
	 </div>
</div>



<p-button outline  type="default" @click.prevent="goToTask()">View Task</p-button>
<p-button outline  type="default" @click.prevent="goToCertDocument()">View Share Certificate</p-button>


    <div style="margin-top:60px;max-width:350px;">
    
    <h5>Certificate Status</h5>
    
            <fg-input>
                  <el-select
                  			class="select-primary"
                             size="large"
                             placeholder="Select Status"
                             v-model="cert_status">
                    <el-option v-for="option in selects.c_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
    
   </div>
	
	<p-button  type="info" @click.prevent="editCertStatus">Update Status</p-button>
	<p-button  type="danger" @click.prevent="deleteCert">Delete Share Certificate</p-button>
</card> 

    
    


<!-- end officers -->
   


  </div>
</template>
<script>
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  export default {
    components: {
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
     mounted() {

      	
      	
      	let o_uri = this.$base_url+'/api/v1/shareholders/share_cert/'+ this.$route.params.scid+"/entity/"
     		+ this.$route.params.eid;
			 ApiService.get(o_uri).then(response => {
				this.coy =  response.data.entity;
				this.share_cert = response.data.share_cert;
				this.cert_status = response.data.share_cert.status;
			    this.cert_document_id = response.data.cert_document_id;
			})
      	
      	
    },
    data () {
      return {
        activeName: 'first',
        enabledRadio: '2',
        coy:[],
        cert_document_id: '',
        cert_status: '',
        share_cert:{
        	shareholder:{person:''}
        	
        },
        selects: {
          c_status: [
            {value: 1, label: 'Pending'},
            {value: 4, label: 'Active'},
            {value: 5, label: 'Cancelled'},
		   ],
        },
      }
    },
    methods:{
      goToCertDocument(){
      	this.$router.push( '/view-document/'+ this.cert_document_id+"/0");
      },
      goToTask(){
      	 this.$router.push( '/edit-task/'+this.share_cert.task_id+'/entity/'+this.$route.params.eid)
      },
	  goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.$route.params.eid);
	  },
	  deleteCert(){
	  
	 	 const vm = this;
      		swal({
					title: 'Are you sure?',
					text: 'This share certificate will be deleted permanently.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/shareholders/delete_cert';
					
					 ApiService.post(uri, {"scid":  vm.$route.params.scid}).then(response => {
	
							swal({
							  title: 'Deleted',
							  text: 'Share certificate has been deleted successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								 vm2.$router.push( '/view-entity/'+vm2.$route.params.eid);
							
							})
							//end swal
						
						
					})


				  })//end swal
	  
	  
	  
	  
	  
	  },
	  editCertStatus(){
	  		let uri = this.$base_url+'/api/v1/shareholders/edit_cert';
      		ApiService.post(uri, {
      			"scid": this.$route.params.scid,
      			 "cert_status": this.cert_status
      		
      		}).then(response => {
      	
         			 this.$router.push('/edit-shareholder/'+this.share_cert.shareholder_id+'/entity/'+this.$route.params.eid+"/" 
         			 					+this.share_cert.share_type)
         		
     		 })
	  
	  }


    },

    
  }
</script>
<style>

.cs_coy_detail_row{
	margin-top:25px;margin-bottom:25px;
}
.cs_coy_detail_label{
	font-weight:bold!important;
	color:#000!important;
	text-align:left!important;
}

 .cs_coy_detail_{
 	padding:10px 5px;
 	padding-left:20px;
 	border-bottom:1px dotted #000;
 }

</style>
